module.exports = __webpack_public_path__ + "img/background.debb73ad.png";